
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function LogOut(props) {
    const path = [
        'M15 2c0-.6.4-1 1-1s1 .4 1 1v9c0 .6-.4 1-1 1s-1-.4-1-1V2zm4 .4v2c5.2 ',
        '1.3 9 6 9 11.6 0 6.6-5.4 12-12 12S4 22.6 4 16c0-5.6 3.8-10.3 9-11.6v-2C6.7 ',
        '3.7 2 9.3 2 16c0 7.7 6.3 14 14 14s14-6.3 14-14c0-6.7-4.7-12.3-11-13.6z'
    ].join('');

    return (
        <SvgIcon {...props}>
            <path d={path} />
        </SvgIcon>
    );
}

LogOut.defaultProps = {
    viewBox: '0 0 32 32'
};

export default LogOut;
